export default "__VITE_ASSET__BXxK8bny__"